import { manifest as delayConditionManifest } from './delay.condition.js';
import { manifest as switchConditionManifest } from './switch.condition.js';

export const manifests: Array<UmbExtensionManifest> = [delayConditionManifest, switchConditionManifest];
